/* Trappbutiken – NCS-kod → skärmfärg. DELAD av alla tre konfiguratorerna (ledstången sedan
   2026-09-18, för målad björk med egen NCS). Laddas som vanligt script före konfiguratorns
   egna filer och exponerar window.WubsNCS.

   Kunden kan ange EGEN NCS-kod; utan den här visade 3D:n en generisk grå platta oavsett kod.

   Omräkningen är den PUBLIKA de facto-standarden: bågsegment per elementarfärg som ger
   kulörtonen, avmättning mot gråaxeln efter kulörtheten, och en linjärt korrigerad svarthet.
   Källa: `ncs-color` (MIT © Frederik Ring, github.com/m90/ncs-color) – samma algoritm som
   w3color.js, alltså samma värden som w3schools NCS-lista (verifierat: S 2060-B → #399bd6,
   S 1050-Y90R → #f15045, S 4050-B → #387aa1, S 2050-Y → #d6c251).

   ⚠️ **Det finns ingen offentlig OFFICIELL NCS→sRGB-tabell.** NCS Colour AB licensierar de
   exakta värdena (NCS Navigator / NCS Colour Data). Det publika är formler av det här slaget –
   w3schools kallar dem själva "look alike"-färger. Skärmfärgen beror dessutom på glans, ljus
   och skärm. Fabriken målar efter KODEN, inte efter det vi visar.
   ⚠️ En egen enklare modell (kulört + vitt + svart, linjär interpolation mellan elementar-
   färgerna) provades först och låg klart sämre på mättade kulörer: S 1050-Y90R blev dammrosa
   #cb717d i stället för laxröd #f15045. Den viktigaste skillnaden är att NCS svarthet INTE är
   en linjär inblandning av svart – `S = 1.05·Sn − 5.25` gör att 0502-Y hamnar på nästan rent
   vitt, vilket är hur koden faktiskt läses.
   ⚠️ Ligger HÄR och inte i 3D-filen: formulärets swatch måste fungera även utan WebGL, och en
   kopia i båda filerna hade blivit två sanningar. 3D:n läser window.WubsNCS. */
window.WubsNCS = (function () {
  var GRANNE = { Y: 'R', R: 'B', B: 'G', G: 'Y' };          // NCS-cirkelns ordning
  /* Tolerant inmatning – "NCS S 2060-G20Y", "S 0502-Y", "0502-Y", "S1050-Y90R", "s 0500 n".
     (Referensimplementationen kräver exakt "NCS ..." i versaler; kunder skriver inte så.) */
  var RE = /^\s*(?:ncs\s*)?s?\s*(\d{2})(\d{2})\s*[-–—\s]?\s*(n|[yrbg])\s*(\d{1,2})?\s*([yrbg])?\s*$/i;

  function rgb(kod) {
    var m = RE.exec(String(kod || ''));
    if (!m) return null;
    var Sn = +m[1], Cn = +m[2], C1 = m[3].toUpperCase();
    var N = m[4] ? +m[4] : 0, C2 = m[5] ? m[5].toUpperCase() : null;
    if (Sn + Cn > 100) return null;                          // finns inte i systemet

    if (C1 === 'N') {                                        // gråskalan
      if (m[4] || C2) return null;
      var v = Math.trunc((1 - Sn / 100) * 255);
      return [v, v, v];
    }
    /* ⚠️ NCS blandar bara GRANNAR i färgcirkeln, och algoritmen nedan använder bara FÖRSTA
       bokstaven + talet – "Y50B" hade alltså gett samma färg som "Y50R" utan att klaga.
       En kod som inte finns ska avvisas, inte renderas som något trovärdigt men påhittat. */
    if (C2 ? (GRANNE[C1] !== C2 || !(N >= 0 && N <= 100)) : (m[4] != null)) return null;

    var S = 1.05 * Sn - 5.25, C = Cn, Ra, Ba, Ga, x;

    if (C1 === 'Y' && N <= 60) Ra = 1;
    else if ((C1 === 'Y' && N > 60) || (C1 === 'R' && N <= 80)) {
      x = C1 === 'Y' ? N - 60 : N + 40;
      Ra = (Math.sqrt(14884 - x * x) - 22) / 100;
    } else if ((C1 === 'R' && N > 80) || C1 === 'B') Ra = 0;
    else if (C1 === 'G') { x = N - 170; Ra = (Math.sqrt(33800 - x * x) - 70) / 100; }

    if (C1 === 'Y' && N <= 80) Ba = 0;
    else if ((C1 === 'Y' && N > 80) || (C1 === 'R' && N <= 60)) {
      x = (C1 === 'Y' ? N - 80 : N + 20) + 20.5;
      Ba = (104 - Math.sqrt(11236 - x * x)) / 100;
    } else if ((C1 === 'R' && N > 60) || (C1 === 'B' && N <= 80)) {
      x = (C1 === 'R' ? N - 60 : N + 40) - 60;
      Ba = (Math.sqrt(10000 - x * x) - 10) / 100;
    } else if ((C1 === 'B' && N > 80) || (C1 === 'G' && N <= 40)) {
      x = (C1 === 'B' ? N - 80 : N + 20) - 131;
      Ba = (122 - Math.sqrt(19881 - x * x)) / 100;
    } else if (C1 === 'G' && N > 40) Ba = 0;

    if (C1 === 'Y') Ga = (85 - 17 / 20 * N) / 100;
    else if (C1 === 'R' && N <= 60) Ga = 0;
    else if (C1 === 'R') { x = (N - 60) + 35; Ga = (67.5 - Math.sqrt(5776 - x * x)) / 100; }
    else if (C1 === 'B' && N <= 60) { x = N - 68.5; Ga = (6.5 + Math.sqrt(7044.5 - x * x)) / 100; }
    else if ((C1 === 'B' && N > 60) || (C1 === 'G' && N <= 60)) Ga = 0.9;
    else if (C1 === 'G') { x = N - 60; Ga = (90 - x / 8) / 100; }

    var mitt = (Ra + Ga + Ba) / 3;
    var Rc = (mitt - Ra) * (100 - C) / 100 + Ra;
    var Gc = (mitt - Ga) * (100 - C) / 100 + Ga;
    var Bc = (mitt - Ba) * (100 - C) / 100 + Ba;
    var topp = Math.max(Rc, Gc, Bc);
    if (!(topp > 0)) return null;
    var k = (100 - S) / (100 * topp);
    var ut = [Rc, Gc, Bc].map(function (v) {
      return Math.max(0, Math.min(255, Math.trunc(v * k * 255)));
    });
    return ut.every(function (v) { return isFinite(v); }) ? ut : null;
  }

  return {
    rgb: rgb,
    hex: function (kod) {
      var c = rgb(kod);
      return c ? '#' + c.map(function (v) { return ('0' + v.toString(16)).slice(-2); }).join('') : null;
    }
  };
})();
